/* src/app/shared-components/restore-modal/restore-modal.component.scss */
.modal-header {
  padding-bottom: 0.9375rem;
}
.modal-header .modal-title {
  font-weight: 300;
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}
:host ::ng-deep .modal-header .item-name {
  font-weight: 400;
}
.close {
  background-color: #ffffff;
  outline: none;
  box-shadow: none;
}
.close img {
  height: 1.5625rem;
  width: 1.5625rem;
}
.description-modal {
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 300;
  font-family: EYInterstate;
  color: rgba(46, 46, 56, 0.64);
  margin-bottom: 2.5rem;
}
.modal-body {
  padding-right: 3.75rem;
  padding-bottom: 0.5rem;
}
.modal-footer .btn-outline-dark {
  margin-right: 1.5rem;
}
.destination-helper {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin: 0.5rem 0 0 0;
}
/*# sourceMappingURL=restore-modal.component.css.map */
